import React from 'react'
import { ThemeContext } from '../../theme/ThemeChanger';
import Fade from 'react-reveal/Fade';
import 'react-accessible-accordion/dist/fancy-example.css';
import { skills } from '../../data';

export const SkillDetails = () => {

    const { theme } = React.useContext(ThemeContext)

    return (
        <Fade bottom duration={2000} delay={200} distance="30%">
            <div className='skill-progress'>
                {skills.map((item) => (
                    <div key={item.id} className={theme ? 'tech-stack' : 'light-teck-stack'}>
                        <img src={item.src} alt='logo' className='tech-stack-img'/>
                        <p>
                            {item.skillName}
                        </p>
                    </div>
                ))}
            </div>
        </Fade>
    )
}
